import React from 'react';
import { withRouter } from 'react-router';
import DownloadProgressBar from './DownloadProgressBar';
import { DownloadDataModal } from './DownloadDataModal';
import { FileArchiveContext } from 'contexts/FileArchiveContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import Section from '../components/Section';
import TailSpendPreview from './TailSpendPreview';
import { PERMISSIONS } from 'contexts/PermissionsContext';
import LatestUpdateAlert from '../components/LatestUpdateAlert';
import {
	ApButtonSecondary,
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import {
	generateSpendCube,
	generateTailSpendAnalysisFile,
} from 'utils/apiRequests';
import {
	FileDownloadContainer,
	DownloadButtonWrapper,
	LatestUpdateSection,
	ButtonWrapper,
	ScrollWrapper,
} from './styles';
import { LoaderWrapper, ScrollContainer } from '../Data.styles';

const SETTINGS_PAGE = '/settings';
const TAIL_SPEND_ANCHOR = 'tail_spend';

class DownloadRawDataForm extends React.Component {
	state = {
		fileDownloadFailed: false,
		showProgressBar: false,
		isDownloadModalOpen: false,
	};

	handleFileExportReady = errorMsg => {
		if (errorMsg) {
			this.setState({
				fileDownloadFailed: true,
			});

			return;
		}

		this.setState({
			showProgressBar: false,
		});
	};

	handleCloseProgressBar = () => {
		this.setState({
			showProgressBar: false,
		});
	};

	handleTailSpendEdit = () => {
		this.props.history.push({
			pathname: SETTINGS_PAGE,
			hash: TAIL_SPEND_ANCHOR,
			state: { backRoute: this.props.location.pathname },
		});
	};

	scheduleSpendCube = params => {
		this.setState({
			showProgressBar: true,
			isSpendCubeSchedule: true,
			fileDownloadFailed: false,
		});

		setTimeout(() => {
			this.handleCloseProgressBar();
		}, 5000);

		generateSpendCube(params)
			.then(() => {
				this.setState({
					fileDownloadFailed: false,
				});
			})
			.catch(() => {
				this.setState({
					fileDownloadFailed: true,
				});
			});
	};

	generateTailSpendAnalysisFile = () => {
		this.setState({
			showProgressBar: true,
			isSpendCubeSchedule: true,
			fileDownloadFailed: false,
		});

		setTimeout(() => {
			this.handleCloseProgressBar();
		}, 5000);

		generateTailSpendAnalysisFile()
			.then(() => {
				this.setState({
					fileDownloadFailed: false,
				});
			})
			.catch(() => {
				this.setState({
					fileDownloadFailed: true,
				});
			});
	};

	setSegmentDownloadLinkEnabled = segmentDownloadLinkEnabled => {
		this.setState({ segmentDownloadLinkEnabled });
	};

	showPeriodConfigModal = () => {
		this.setState({
			isDownloadModalOpen: true,
		});
	};

	closePeriodConfigModal = () => {
		this.setState({
			isDownloadModalOpen: false,
		});
	};

	render() {
		const {
			fileDownloadFailed,
			showProgressBar,
			isSpendCubeSchedule,
			isDownloadModalOpen,
			segmentDownloadLinkEnabled,
		} = this.state;
		const { permissions, fileArchive } = this.props;
		const canDownloadSpendCube = permissions.includes(PERMISSIONS.ExcelRead);
		const canEditTailSpend = permissions.includes(PERMISSIONS.SettingsWrite);
		const progressMessage = !isSpendCubeSchedule
			? 'Generating file... The download will start automatically. Thank you.'
			: 'Generating file... You will receive a notification when the file has been generated';

		if (!fileArchive) {
			return (
				<LoaderWrapper>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoaderWrapper>
			);
		}

		const lastUploadedFile =
			fileArchive && fileArchive[0] ? fileArchive[0] : null;

		return (
			<ScrollContainer>
				<FileDownloadContainer>
					<LatestUpdateSection>
						<LatestUpdateAlert
							type={lastUploadedFile ? lastUploadedFile.fileType : null}
							user={lastUploadedFile ? lastUploadedFile.userName : null}
							date={lastUploadedFile ? lastUploadedFile.date : null}
						/>
					</LatestUpdateSection>

					{canDownloadSpendCube && (
						<Section title="Download">
							<DownloadButtonWrapper>
								<ButtonWrapper>
									<ApButtonMain
										onClick={this.showPeriodConfigModal}
										iconName="outline_save_alt"
									>
										Download data
									</ApButtonMain>
								</ButtonWrapper>

								<ApButtonSecondary
									onClick={this.generateTailSpendAnalysisFile}
									disabled={!segmentDownloadLinkEnabled}
									iconName="outline_save_alt"
								>
									Download tail spend analysis .xls
								</ApButtonSecondary>

								{showProgressBar && (
									<DownloadProgressBar
										error={fileDownloadFailed}
										successMessage={progressMessage}
										onClose={this.handleCloseProgressBar}
									/>
								)}
							</DownloadButtonWrapper>
						</Section>
					)}

					<Section
						title="Tail Spend"
						onEdit={canEditTailSpend ? this.handleTailSpendEdit : null}
					>
						<ScrollWrapper>
							<TailSpendPreview
								setSegmentDownloadLinkEnabled={
									this.setSegmentDownloadLinkEnabled
								}
							/>
						</ScrollWrapper>
					</Section>
					{isDownloadModalOpen && (
						<DownloadDataModal
							onClose={this.closePeriodConfigModal}
							onSubmit={this.scheduleSpendCube}
						/>
					)}
				</FileDownloadContainer>
			</ScrollContainer>
		);
	}
}

export default withRouter(props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<FileArchiveContext.Consumer>
				{({ fileArchive }) => (
					<DownloadRawDataForm
						{...props}
						fileArchive={fileArchive}
						permissions={permissions || []}
					/>
				)}
			</FileArchiveContext.Consumer>
		)}
	</PermissionsContext.Consumer>
));
